import LoginPage from '../../common/components/login/LoginPage';

import UserAccountPage from '../../professional/components/user-account/UserAccountPage.vue';

// Professional components imports.
import HomePage from '../../professional/components/home/HomePage';
import AssessmentStartPage from '../components/assessment-start/AssessmentStartPage';
import ChooseMainSymptomPage from '../../professional/components/choose-main-symptom/ChooseMainSymptomPage';
import SymptomsQuestionsPage from '../components/symptoms-questions/symptoms-panels/SymptomsQuestionsPage.vue';
import AssessmentListPage from '../../professional/components/assessment-list/AssessmentListPage.vue'
import EvaluationPage from '../../professional/components/evaluation/EvaluationPage.vue';
import ScoringPage from '../../professional/components/scoring/ScoringPage.vue';
import SummaryPage from '../../professional/components/summary/SummaryPage.vue';
import TestPage from '../../professional/components/tests/TestPage.vue';
import TestTreePage from '../../professional/components/tests/TestTreePage.vue';
import RunTestPage from '../../professional/components/tests/RunTestPage.vue';
import AssessmentSymptomListView from '../components/symptoms-questions/symptoms-priority-list/AssessmentSymptomsPriorityListPage.vue';
import AssessmentStartListPage from '../components/assessment-start/AssessmentStartListPage.vue';
import AssessmentSharePage from '../../professional/components/assessment-share/AssessmentSharePage.vue';

let professionalRoutesPrefix = "";


// ======================================================================
// PROFESSIONAL routes.
// ======================================================================

let professionalRoutes = [
    {
        path: professionalRoutesPrefix + '/home',
        name: 'HomePage',
        component: HomePage,
        meta: {
            forAuth: true,
        }
    },
    {
        path: professionalRoutesPrefix + '/assessment-start',
        name: 'AssessmentStartPage',
        component: AssessmentStartPage,
        meta: {
            forAuth: true
        }
    },
    {
        path: professionalRoutesPrefix + '/main-symptom',
        name: 'ChooseMainSymptomPage',
        component: ChooseMainSymptomPage,
        meta: {
            forAuth: true
        }
    },
    {
        path: professionalRoutesPrefix + '/symptoms-questions',
        name: 'SymptomsQuestionsPage',
        component: SymptomsQuestionsPage,
        meta: {
            forAuth: true
        }
    },
    {
        path: professionalRoutesPrefix + '/assessment-list',
        name: 'AssessmentListPage',
        component: AssessmentListPage,
        meta: {
            forAuth: true
        }
    },

    {
        path: professionalRoutesPrefix + '/evaluation',
        name: 'EvaluationPage',
        component: EvaluationPage,
        meta: {
            forAuth: true
        }
    },
    {
        path: professionalRoutesPrefix + '/scoring',
        name: 'ScoringPage',
        component: ScoringPage,
        meta: {
            forAuth: true
        }
    },
    {
        path: professionalRoutesPrefix + '/summary',
        name: 'SummaryPage',
        component: SummaryPage,
        meta: {
            forAuth: true
        }
    },
    {
        path: professionalRoutesPrefix + '/tests',
        name: 'TestPage',
        component: TestPage,
        meta: {
            forAuth: true,
        }
    },
    {
        path: professionalRoutesPrefix + '/test-tree',
        name: 'TestTreePage',
        component: TestTreePage,
        meta: {
            forAuth: true,
        }
    },
    {
        path: professionalRoutesPrefix + '/run-test',
        name: 'RunTestPage',
        component: RunTestPage,
        meta: {
            forAuth: true,
        }
    },
    {
        path: professionalRoutesPrefix + '*',
        redirect: '/',
        name: 'UndefinedPages',
        component: LoginPage,
        meta: {
            forVisitors: true
        }
    },
    {
        path: professionalRoutesPrefix + '/user-account',
        name: 'UserAccountPage',
        component: UserAccountPage,
        meta: {
            forAuth: true,
        }
    },
    {
        path: professionalRoutesPrefix + '/symptoms-list',
        name: 'AssessmentSymptomsPriorityListPage',
        component: AssessmentSymptomListView,
        meta: {
            forAuth: true
        }
    },
    {
        path: professionalRoutesPrefix + '/assessment-start-list',
        name: 'AssessmentStartListPage',
        component: AssessmentStartListPage,
        meta: {
            forAuth: true
        }
    },
    {
        path: professionalRoutesPrefix + '/assessment-share',
        name: 'AssessmentSharePage',
        component: AssessmentSharePage,
        meta: {
            forAuth: true
        }
    },
];





export default professionalRoutes;



// WEBPACK FOOTER //
// ./src/professional/router/routes-pro.js